// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    width: var(--loader-size, 100px); /* Default size is 100px */
    height: var(--loader-size, 100px); /* Default size is 100px */
    border-radius: 50%;
    position: relative;
    box-shadow: 0 0 30px 4px rgba(255, 255, 255, 0.5) inset,
      0 5px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }
  
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 45%;
    top: -40%;
    background-color: #2e2e2e;
    animation: wave 5s linear infinite;
  }
  
  .loader:before {
    border-radius: 30%;
    background: rgba(122, 122, 122, 0.4);
    animation: wave 5s linear infinite;
  }
  
  @keyframes wave {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/loader.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC,EAAE,0BAA0B;IAC5D,iCAAiC,EAAE,0BAA0B;IAC7D,kBAAkB;IAClB,kBAAkB;IAClB;oCACgC;IAChC,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,kCAAkC;EACpC;;EAEA;IACE;MACE,oBAAoB;IACtB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".loader {\n    width: var(--loader-size, 100px); /* Default size is 100px */\n    height: var(--loader-size, 100px); /* Default size is 100px */\n    border-radius: 50%;\n    position: relative;\n    box-shadow: 0 0 30px 4px rgba(255, 255, 255, 0.5) inset,\n      0 5px 12px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n  }\n  \n  .loader:before,\n  .loader:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 45%;\n    top: -40%;\n    background-color: #2e2e2e;\n    animation: wave 5s linear infinite;\n  }\n  \n  .loader:before {\n    border-radius: 30%;\n    background: rgba(122, 122, 122, 0.4);\n    animation: wave 5s linear infinite;\n  }\n  \n  @keyframes wave {\n    0% {\n      transform: rotate(0);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
